import '../css/app.css';
import 'lazysizes';
import Alpine from 'alpinejs';
import Clipboard from 'clipboard';

const clipboard = new Clipboard('.clipboard-btn');

Alpine.start();
